import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Collapse } from "react-bootstrap";
import UserInfo from "./UserInfo";
import Nav from "./Nav";
import VersionInfo from "./VersionInfo";

// import logoImg from '../../assets/icons/EY-logo.png';
// import logoImg from '../../assets/images/logo1.png';

class SideBar extends Component {
  state = {};

  render() {
    let { location, backgroundColor, enableBackgroundImage, backgroundImage } =
      this.props;

    return (
      <div
        className="sidebar"
        data-color={backgroundColor}
        data-image={backgroundImage}
      >
        <div className="brand">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <svg
              width="90"
              height="11"
              viewBox="0 0 90 11"
              style={{ display: "block", marginBottom: "2px" }}
            >
              <polygon points="0,11 90,0 90,11" fill="#FFE600" />
            </svg>
            <span
              style={{
                display: "block",
                fontSize: "22px",
                fontWeight: "800",
                fontStyle: "italic",
                letterSpacing: "0.18em",
                background:
                  "linear-gradient(135deg, #1a1a1a 20%, #C89B00 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                whiteSpace: "nowrap",
                userSelect: "none",
                lineHeight: "1",
              }}
            >
              ERIX
            </span>
          </div>
        </div>
        <div className="sidebar-wrapper">
          <UserInfo />
          <div className="line"></div>
          <Nav />
          <VersionInfo />
        </div>
        <div
          className="sidebar-background"
          style={{
            backgroundImage: enableBackgroundImage
              ? "url(" + backgroundImage + ")"
              : null,
          }}
        ></div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  enableBackgroundImage: state.ThemeOptions.enableBackgroundImage,
  backgroundColor: state.ThemeOptions.backgroundColor,
  backgroundImage: state.ThemeOptions.backgroundImage,
});

export default withRouter(connect(mapStateToProps)(SideBar));



// WEBPACK FOOTER //
// src/components/SideBar/index.js